import React from "react";
import { Link } from "react-router-dom";
import { User as UserIcon, Calendar, CheckCircle } from "lucide-react";
import PageRoutes from "@/utils/constants";

interface AccountDetailsSectionProps {
  memberSinceDate: string;
}

export function AccountDetailsSection({ memberSinceDate }: AccountDetailsSectionProps) {
  return (
    // Inline vertical padding: Tailwind py utilities resolve to 0 inside .v2,
    // so the extra space around the section divider is set here.
    <div className="px-4 sm:px-6" style={{ paddingTop: "34px", paddingBottom: "34px" }}>
      <div className="flex items-center gap-2 mb-6">
        <UserIcon className="w-5 h-5 text-foreground" />
        <h4 className="text-2xl font-bold text-foreground" style={{ fontWeight: "bold" }}>Account Details</h4>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-border">
        {/* Member Since */}
        <div className="flex flex-col pb-6 md:pb-0 v2-profile-account-detail-item" style={{ paddingRight: "24px" }}>
          <div className="flex items-center gap-2 mb-2 text-muted-foreground">
            <Calendar className="w-5 h-5 text-muted-foreground/60" />
            <span className="text-sm font-medium">Member Since</span>
          </div>
          <span className="text-base font-normal text-foreground">{memberSinceDate || "-"}</span>
        </div>

        {/* Terms of Service */}
        <div className="flex flex-col py-6 md:py-0 v2-profile-account-detail-item" style={{ paddingLeft: "24px", paddingRight: "24px" }}>
          <div className="flex items-center gap-2 mb-2 text-muted-foreground">
            <CheckCircle className="w-5 h-5 text-green-500 fill-green-50" />
            <span className="text-sm font-medium">Terms of Service</span>
          </div>
          <span className="text-base font-normal mb-2 text-foreground">
            Accepted
          </span>
          <Link
            to={PageRoutes.TermAndConditions}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-action hover:underline font-normal"
          >
            View Terms
          </Link>
        </div>

        {/* Privacy Policy */}
        <div className="flex flex-col pt-6 md:pt-0 v2-profile-account-detail-item" style={{ paddingLeft: "24px" }}>
          <div className="flex items-center gap-2 mb-2 text-muted-foreground">
            <CheckCircle className="w-5 h-5 text-green-500 fill-green-50" />
            <span className="text-sm font-medium">Privacy Policy</span>
          </div>
          <span className="text-base font-normal mb-2 text-foreground">
            Accepted
          </span>
          <Link
            to={PageRoutes.PrivacyPolicy}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-action hover:underline font-normal"
          >
            View Policy
          </Link>
        </div>
      </div>
    </div>
  );
}
